/* Rail switching for "Extra menu" mega-panels (static content, no fetch).
   The existing kingpin-mega-menu.js still opens/closes the panel via data-kp-pillar / data-kp-panel. */
(function () {
  function activate(tab) {
    var panel = tab.closest('[data-kp-extra-panel]');
    if (!panel) return;
    var key = tab.getAttribute('data-kp-extra-tab');
    panel.querySelectorAll('[data-kp-extra-tab]').forEach(function (button) {
      var on = button === tab;
      button.classList.toggle('is-active', on);
      button.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    panel.querySelectorAll('[data-kp-extra-group]').forEach(function (group) {
      group.hidden = group.getAttribute('data-kp-extra-group') !== key;
    });
  }

  document.addEventListener('click', function (event) {
    var tab = event.target.closest('[data-kp-extra-tab]');
    if (tab) activate(tab);
  });

  // Match the pillar rails if they switch on hover (desktop only).
  document.addEventListener('mouseover', function (event) {
    if (!window.matchMedia('(hover: hover)').matches) return;
    var tab = event.target.closest('[data-kp-extra-tab]');
    if (tab && !tab.classList.contains('is-active')) activate(tab);
  });

  // Load the banner image when the panel is first shown, in case the main script
  // only handles banners inside its own panels.
  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      var panel = mutation.target;
      if (panel.hidden) return;
      panel.querySelectorAll('img[data-kp-banner-src]:not([src])').forEach(function (img) {
        img.src = img.getAttribute('data-kp-banner-src');
      });
    });
  });
  document.querySelectorAll('[data-kp-extra-panel]').forEach(function (panel) {
    observer.observe(panel, { attributes: true, attributeFilter: ['hidden'] });
  });
})();
